import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { IFin } from "./IFin";
import {IFinSvc,fin_api} from "./IFinSvc"
import { NakladyParams } from "./INakladyParams";


export class FinSvc implements IFinSvc {

    public async save(fin: IFin): Promise<IFin | undefined> {
        const ret = await bus.call(fin_api.save,fin);
        if (ret && ret._id) return (<IFin> ret);
        else return undefined
    }

    public async find_by_id(_id: any): Promise<IFin | undefined> {
        const ret = await bus.call(fin_api.find_by_id,{_id:_id});
        if (ret && ret._id) {

            if (!ret.naklady) ret.naklady=new NakladyParams();
            if (!ret.artworks) ret.artworks =new NakladyParams();
            return (<IFin> ret);
        }
        else return undefined
    }

}
      
  
